export function vectorsToSvgPath(vectors) {
    let path = "M";
    for (const vector of vectors) {
        path += ` ${vector.x} ${vector.y} L`;
    }
    return path.slice(0, -1) + " Z";
}
//# sourceMappingURL=vectorsToSvgPath.js.map